import { render, staticRenderFns } from "./DeckVariations.vue?vue&type=template&id=47d6b9d6"
import script from "./DeckVariations.vue?vue&type=script&lang=ts"
export * from "./DeckVariations.vue?vue&type=script&lang=ts"
import style0 from "./DeckVariations.vue?vue&type=style&index=0&id=47d6b9d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports